import { FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { AppTester } from "../../../supporting";
import { useTranslation } from "react-i18next";
import { LayoutConst } from 'core';

const Wrapper = styled(FlexBox)`
  cursor: pointer;
  & > div > div:last-child {
      top: 35px;
  }

  @media(max-width: ${LayoutConst.screen.l}px) {
    margin-left: 16px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    margin: 0 0px 0 16px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin: 0 16px 0 0;
  }
  @media (max-width: ${LayoutConst.screen.sm}px) {
      svg {
        height: 24px;
        width: 24px;
      }
  }
`

const GameButton = () => {
  const history = useHistory();
  const isTab = useBreakpoint(LayoutConst.screen.m);
  const isGeo = AppTester.isGeograffee()
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const { t } = useTranslation();

  const baseStyle = { padding: '2px 8px 4px' };
  const geoStyle =
      (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};
  const combinedStyle = { ...baseStyle, ...geoStyle };



  return (
    <Wrapper onClick={() => history.push('/game')}>
      <HintTooltip 
    // @ts-ignore
    customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper}
                   text={t("hints.game")}>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
          <rect width="24" height="24" fill="white"/>
          <rect x="10.5" y="10.5" width="9" height="9" rx="2.5" fill="white" stroke="#909090"/>
          <path d="M13 13L17 17" stroke="#909090" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 13L13 17" stroke="#909090" stroke-linecap="round" stroke-linejoin="round"/>
          <rect x="4.5" y="4.5" width="9" height="9" rx="2.5" fill="white" stroke="#909090"/>
          <path d="M7 9L8.6 11L11 7" stroke="#909090" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </HintTooltip>
    </Wrapper>
  )
}

export default GameButton;import { FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { AppTester } from "../../../supporting";
import { useTranslation } from "react-i18next";
import { LayoutConst } from 'core';

const Wrapper = styled(FlexBox)`
  cursor: pointer;
  & > div > div:last-child {
      top: 35px;
  }

  @media(max-width: ${LayoutConst.screen.l}px) {
    margin-left: 16px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    margin: 0 0px 0 16px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin: 0 16px 0 0;
  }
  @media (max-width: ${LayoutConst.screen.sm}px) {
      svg {
        height: 24px;
        width: 24px;
      }
  }
`

const GameButton = () => {
  const history = useHistory();
  const isTab = useBreakpoint(LayoutConst.screen.m);
  const isGeo = AppTester.isGeograffee()
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const { t } = useTranslation();

  const baseStyle = { padding: '2px 8px 4px' };
  const geoStyle =
      (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};
  const combinedStyle = { ...baseStyle, ...geoStyle };



  return (
    <Wrapper onClick={() => history.push('/game')}>
      <HintTooltip 
    // @ts-ignore
    customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper}
                   text={t("hints.game")}>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
          <rect width="24" height="24" fill="white"/>
          <rect x="10.5" y="10.5" width="9" height="9" rx="2.5" fill="white" stroke="#909090"/>
          <path d="M13 13L17 17" stroke="#909090" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 13L13 17" stroke="#909090" stroke-linecap="round" stroke-linejoin="round"/>
          <rect x="4.5" y="4.5" width="9" height="9" rx="2.5" fill="white" stroke="#909090"/>
          <path d="M7 9L8.6 11L11 7" stroke="#909090" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </HintTooltip>
    </Wrapper>
  )
}

export default GameButton;